import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import serverList from "../../../components/serverList/serverOptions.vue";
import PayOptions from "../../../components/serverList/payOptions.vue";
import { payItemCount } from "@/api/data";
import { getPayMap, getPayRmbMap, getGameServerMap } from "@/utils/dictionary";
export default {
  name: "payItemCount",
  components: {
    serverList: serverList,
    DataOptions: DataOptions,
    PayOptions: PayOptions
  },
  data: function data() {
    return {
      tableData: [],
      searchInfo: {
        sdate: "",
        edate: "",
        server_id: ["0"]
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      payArray: [],
      payInfo: [],
      serverInfo: [],
      payRmbMap: {}
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    totalSort: function totalSort(a, b) {
      console.log(a, b);
      if (this.payRmbMap[a.good_id] * a.finish_num < this.payRmbMap[b.good_id] * b.finish_num) {
        return -1;
      }
      // return -1;
    },
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPayMap();
            case 2:
              _this.payInfo = _context.sent;
              for (index in _this.payInfo) {
                _this.payArray.push({
                  pay_id: index,
                  pay_name: _this.payInfo[index]
                });
              }
              _context.next = 6;
              return getPayRmbMap();
            case 6:
              _this.payRmbMap = _context.sent;
              _context.next = 9;
              return getGameServerMap();
            case 9:
              _this.serverInfo = _context.sent;
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    searchEvent: function searchEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.formData[0];
              _this2.searchInfo.edate = _this2.formData[1];
              console.log(_this2.searchInfo);
              _context2.next = 5;
              return payItemCount(_this2.searchInfo);
            case 5:
              res = _context2.sent;
              if (res.code == 0) {
                if (res.data.list && res.data.list.length > 0) {
                  _this2.tableData = res.data.list;
                } else {
                  _this2.tableData = [];
                  _this2.$message({
                    message: "暂无数据"
                  });
                }
              } else {
                _this2.tableData = [];
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};